import { render, staticRenderFns } from "./change_heatmap_mode.vue?vue&type=template&id=60f62460&scoped=true&lang=pug&"
import script from "./change_heatmap_mode.vue?vue&type=script&lang=js&"
export * from "./change_heatmap_mode.vue?vue&type=script&lang=js&"
import style0 from "./change_heatmap_mode.vue?vue&type=style&index=0&id=60f62460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f62460",
  null
  
)

export default component.exports